import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
export const baseURL = process.env.NODE_ENV == 'development' ? '/api' : ''
const service = axios.create({
  baseURL,
  // baseURL: '/api',
  timeout: 50000,
})

service.interceptors.request.use(
  (config) => {
    console.log('// 添加请求拦截器')
    console.log(config)
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
let showDialog = true
service.interceptors.response.use(
  (response) => {
    console.log(response)
    if (response.data.code === 0) {
      return response
    } else if (response.data.code === 401) {
      // showDialog &&
      //   MessageBox.confirm('当前账号未登录，是否去登录？', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning',
      //   })
      //     .then(() => {
      //       window.open('https://portal.zjzwfw.gov.cn/uc/sso/login?appId=A330201271550202305000005_1&sp=', '_self')
      //     })
      //     .catch(() => {})
      //     .finally(() => {
      //       showDialog = false
      //     })
      return Promise.reject(response.data.msg)
    } else {
      Message.error(response.data.msg)
      return Promise.reject(response.data.msg)
    }
  },
  (error) => {
    // 对响应错误做点什么
    console.log(error)
    return Promise.reject(error)
  }
)

export function request(config) {
  let reqConfig = {
    method: config.method.toLowerCase(),
    url: config.url,
    data: config.data,
    params: config.params,
  }
  return service.request(reqConfig).then((res) => res.data)
}
